import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import WhatsAppFloating from '../section-components/whatsapp-floating';

class Footer_v1 extends Component {

	componentDidMount() {
		let publicUrl = process.env.PUBLIC_URL + '/'
		const minscript = document.createElement("script");
		minscript.async = true;
		minscript.src = publicUrl + "assets/js/main.js";

		document.body.appendChild(minscript);
	}

	render() {

		let publicUrl = process.env.PUBLIC_URL + '/'
		let imgattr = "Footer logo"

		return (
			<>
				<footer className="footer-area" style={{ backgroundImage: 'url(' + publicUrl + 'assets/img/bg/2.png)' }}>
					<div className="container">
						<div className="row">
							<div className="col-lg-4 col-md-6">
								<div className="footer-widget widget">
									<div className="about_us_widget">
										<Link to="/" className="footer-logo">
											<img src={publicUrl + "assets/img/Logo-novo.png"} alt="footer logo" />
										</Link>
										<p>Viajar é sentir. Estamos aqui para tornar seu sonho um voo inesquecível. Vamos planejar sua próxima história?</p>
										<ul className="social-icon">
											<li>
												<a className="facebook" href="https://www.facebook.com/codingeek.net/" target="_blank"><i className="fa fa-facebook  " /></a>
											</li>
											<li>
												<a className="pinterest" href="https://www.instagram.com/flutuaragencia?igsh=MXZvejVweDBrdTQ0Ng==" target="_blank"><i className="fa fa-instagram" /></a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="footer-widget widget ">
									<div className="widget-contact">
										<h4 className="widget-title">Fale conosco</h4>
										<p>
											<i className="fa fa-map-marker" />
											<span>São Paulo, Brasil</span>
										</p>
										<p className="location">
											<i className="fa fa-envelope-o" />
											<span>comercial@flutuaragencia.com</span>
										</p>
										<p className="telephone">
											<i className="fa fa-phone base-color" />
											<span>
												+55 11 95639‑1599
											</span>
										</p>
										<img
											src={publicUrl + "assets/img/destination-list/cadastur.png"}
											alt="Logotipo Cadastur"
											style={{ marginTop: '10px', maxWidth: '180px' }}
										/>
									</div>
								</div>
							</div>
							<div className="col-lg-2 col-md-6">
								<div className="footer-widget widget">
									<h4 className="widget-title">Acesso rápido</h4>
									<ul className="widget_nav_menu  viaje-go-top">
										<li><Link to="/home-v2">Home</Link></li>
										<li><Link to="/about">Sobre nós</Link></li>
										<li><Link to="/blog">Blog</Link></li>
										<li><Link to="/contact">Contato</Link></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="copyright-inner">
						<div className="copyright-text text-center">
							© Flutuar 2025 todos os direitos reservados. <br />
							CNPJ: 59.718.230/0001-33
						</div>
					</div>

				</footer>
				<WhatsAppFloating />
			</>
		)
	}
}


export default Footer_v1
